<script>import { t, Verbiage } from "@infinitro/content";
import { getIcon } from "../data/icons";
const RemoveIcon = getIcon("RemoveIcon");
</script>

{#if typeof RemoveIcon === 'string'}
	<img src={RemoveIcon} alt={$t(Verbiage.icon_alt, 'alts')} />
{:else if typeof RemoveIcon === 'function'}
	<svelte:component this={RemoveIcon} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
